module.exports = {
      id: "crash500 index-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#crash500 index-usage",
      toString: function () {
        return this.url;
      }
    }